import React, { useState, useEffect } from "react";
// import ScanIcon from './../assets/scan_emoji.png';
// import FooterLogo from './../assets/nexus_logo.webp';
import { HEADER_COLOR, PRIMARY_COLOR } from "../constants/theme";
// import Sidebar from './SidebarScreen';
// import { ReactComponent as UserIcon } from "./../assets/user_icon.svg";
// import { HiOutlineMenu } from "react-icons/hi";

import { HiEye, HiEyeOff } from "react-icons/hi";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassord] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  return (
    <div
      className="container-fluid position-relative"
      style={{
        overflow: "hidden",
        backgroundColor: "#fae5ff",
        zIndex: "20",
      }}
    >
      <div
        className="row w-100 mx-auto flex-column justify-content-between align-items-center position-relative"
        style={{
          minHeight: "100dvh",

          // backgroundColor: '#fae5ff'
        }}
      >
        <div className="col-12 p-0">
          {/* <div className="d-flex mt-4 justify-content-center text-center">
            <h4
              className="text-center"
              style={{
                color: HEADER_COLOR,
              }}
            >
              Change Password
            </h4>
          </div> */}

          <hr style={{ color: "gray" }} />

          <div
            className="row w-100 h-100 mx-auto flex-column align-items-center justify-content-center"
            style={{
              // minHeight: '55vh',
              gap: "40px",
              // paddingTop: '100px'
            }}
          >
            <div className="col-12 p-0">
              <div
                className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                style={{
                  gap: "15px",
                  maxWidth: screenWidth >= 576 ? "310px" : "250px",
                }}
              >
                <div className="col-12 p-0">
                  <div className="d-flex flex-column align-items-start justify-content-center">
                    <label
                      for="forgotPasswordEmail"
                      className="text-start form-label"
                      style={{
                        fontSize: "13.5px",
                        marginLeft: "4px",
                        marginBottom: "3px",
                        fontWeight: "500",
                        color: PRIMARY_COLOR,
                      }}
                    >
                      Old Password
                    </label>

                    <div
                      className="w-100 position-relative d-flex align-items-center"
                      style={{
                        border: "2px solid rgb(203, 108, 230)",
                        borderRadius: "10px",
                        padding: "8px 12px",
                        backgroundColor: "rgb(255,255,255)",
                        // height: '44px'
                      }}
                    >
                      <input
                        className="w-100 login-input text-start"
                        type={showOldPassword ? "text" : "password"}
                        placeholder=""
                        style={{
                          background: "none",
                          outline: "none",
                          border: "none",
                          // width: '222.96px',
                          fontWeight: "400",
                          color: HEADER_COLOR,
                          letterSpacing: "0.01ch",
                          paddingInlineEnd: "22px",
                          fontSize: "13.5px",
                          // paddingInlineEnd: '30px'
                        }}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />

                      <div
                        className="position-absolute d-flex align-items-center justify-content-center"
                        style={{
                          right: "9px",
                          top: "0",
                          height: "100%",
                        }}
                      >
                        {oldPassword !== "" &&
                          (!showOldPassword ? (
                            <HiEye
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowOldPassword(true)}
                            />
                          ) : (
                            <HiEyeOff
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowOldPassword(false)}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 p-0">
                  <div className="d-flex flex-column align-items-start justify-content-center">
                    <label
                      for="forgotPasswordEmail"
                      className="text-start form-label"
                      style={{
                        fontSize: "13.5px",
                        marginLeft: "4px",
                        marginBottom: "3px",
                        fontWeight: "500",
                        color: PRIMARY_COLOR,
                      }}
                    >
                      New Password
                    </label>

                    <div
                      className="w-100 position-relative d-flex align-items-center"
                      style={{
                        border: "2px solid rgb(203, 108, 230)",
                        borderRadius: "10px",
                        padding: "8px 12px",
                        backgroundColor: "rgb(255,255,255)",
                        // height: '44px'
                      }}
                    >
                      <input
                        className="w-100 login-input text-start"
                        type={showPassword ? "text" : "password"}
                        placeholder=""
                        style={{
                          background: "none",
                          outline: "none",
                          border: "none",
                          // width: '222.96px',
                          fontWeight: "400",
                          color: HEADER_COLOR,
                          letterSpacing: "0.01ch",
                          paddingInlineEnd: "22px",
                          fontSize: "13.5px",
                          // paddingInlineEnd: '30px'
                        }}
                        onChange={(e) => setPassord(e.target.value)}
                      />

                      <div
                        className="position-absolute d-flex align-items-center justify-content-center"
                        style={{
                          right: "9px",
                          top: "0",
                          height: "100%",
                        }}
                      >
                        {password !== "" &&
                          (!showPassword ? (
                            <HiEye
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowPassword(true)}
                            />
                          ) : (
                            <HiEyeOff
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowPassword(false)}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 p-0">
                  <div className="d-flex flex-column align-items-start justify-content-center">
                    <label
                      for="forgotPasswordEmail"
                      className="text-start form-label"
                      style={{
                        fontSize: "13.5px",
                        marginLeft: "4px",
                        marginBottom: "3px",
                        fontWeight: "500",
                        color: PRIMARY_COLOR,
                      }}
                    >
                      Repeat Password
                    </label>

                    <div
                      className="w-100 position-relative d-flex align-items-center"
                      style={{
                        border: "2px solid rgb(203, 108, 230)",
                        borderRadius: "10px",
                        padding: "8px 12px",
                        backgroundColor: "rgb(255,255,255)",
                        // height: '44px'
                      }}
                    >
                      <input
                        className="w-100 login-input text-start"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder=""
                        style={{
                          background: "none",
                          outline: "none",
                          border: "none",
                          // width: '222.96px',
                          fontWeight: "400",
                          color: HEADER_COLOR,
                          letterSpacing: "0.01ch",
                          paddingInlineEnd: "22px",
                          fontSize: "13.5px",
                          // paddingInlineEnd: '30px'
                        }}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />

                      <div
                        className="position-absolute d-flex align-items-center justify-content-center"
                        style={{
                          right: "9px",
                          top: "0",
                          height: "100%",
                        }}
                      >
                        {confirmPassword !== "" &&
                          (!showConfirmPassword ? (
                            <HiEye
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowConfirmPassword(true)}
                            />
                          ) : (
                            <HiEyeOff
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowConfirmPassword(false)}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 p-0">
              <div
                className="row w-100 mx-auto flex-column align-items-center justfy-content-center"
                style={{
                  maxWidth: screenWidth >= 576 ? "310px" : "250px",
                }}
              >
                <div className="col-12 p-0">
                  <button
                    className="w-100 btn "
                    style={{
                      // backgroundColor: 'rgb(203, 108, 230)',
                      // color: '#fae5ff',
                      // width: '250px',
                      backgroundColor: "rgb(203, 108, 230)",
                      color: "#fae5ff",
                      borderRadius: "10px",
                      // height: '44px',
                      fontSize: "13.5px",
                      padding: "8.5px 12px",
                    }}
                  >
                    Update Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-12 p-0"
          style={{
            height: "66px",
          }}
        ></div>
        {/* <div className='col-12 p-0' style={{
					// marginTop: '35px'
				}}>
					<div className='row w-100 h-100 mx-auto align-items-center justify-content-center' style={{
						// minHeight: '15vh',
						padding: '0 0 20px 0'
					}}>
						<div className='col-auto p-0'>
							<img className='' src={FooterLogo} alt='footer logo' style={{
								width: '85px'
							}} />
						</div>
					</div>
				</div> */}
      </div>
    </div>
  );
};

export default ChangePassword;
